<template>
  <div class="homeContent">
    <!-- 飞书未绑定提示（非强制，可关闭） -->
    <el-alert
      v-if="fsUnbound && !fsTipHidden"
      title="您尚未绑定飞书账号"
      type="warning"
      show-icon
      :closable="true"
      @close="closeFsTip">
      <span>为方便飞书免登录与服务通知，建议前往
        <el-link type="primary" :underline="false" @click="toBindFeishu" style="vertical-align: baseline;">基本资料</el-link>
        绑定飞书（非强制，可稍后绑定）。
      </span>
    </el-alert>
    <div>
      <div>
        <el-row :gutter="10">
          <el-col :md="24" :lg="12">
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>系统简介</span>
              </div>
              <div class="text">
                本系统主要用于广告订单的录入和相关统计报表的生成。
              </div>
              <div class="text">
                若在使用过程中遇见任何困惑，请及时通过钉钉联系
                <el-link type="primary" @click="toDingDing">
                  管理员 @韦忠 @王飞
                </el-link>
              </div>
            </el-card>
          </el-col>
          <el-col :md="24" :lg="12">
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>消息通知</span>
              </div>
              <div class="text click" v-if="summaryNotify.unread>0" @click="toNotify">
                您有 <span style="font-size: 1.4rem;font-style: italic;color: #F56C6C;font-weight: bold">{{
                  summaryNotify.unread
                }}</span> 条回款认领通知未读
              </div>
              <div v-else>
                没有未读消息通知
              </div>
            </el-card>
          </el-col>
<!--          <el-col :md="24" :lg="8">-->
<!--            <el-card class="box-card" shadow="hover">-->
<!--              <div slot="header" class="clearfix">-->
<!--                <span>近期更新记录</span>-->
<!--              </div>-->
<!--              <div class="text" v-for="(item ,index) in updatedRecord" :key="index">-->
<!--                {{ item.date }}&nbsp;&nbsp;{{ item.content }} 【{{ item.type }}】-->
<!--              </div>-->
<!--            </el-card>-->
<!--          </el-col>-->
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
import {summaryNotify} from "@/api/notify";
import {myThirdPartyBindings} from "@/api/user";

export default {
  name: "home",
  components: {},
  data() {
    return {
      summaryNotify: {read: 0, unread: 0},
      // 首页飞书未绑定检测与提示
      fsUnbound: false,
      fsTipHidden: false,
      updatedRecord: [
        {date: '2026/09/28', content: '基本资料页新增钉钉/飞书绑定状态展示，支持「去绑定」「解绑」，绑定态即时刷新', type: '需求开发'},
        {date: '2026/09/28', content: '新增「我的第三方绑定查询接口」，账号绑定信息展示更准确', type: '功能调整'},
        {date: '2026/09/28', content: '支持把飞书绑定到当前账号（「去绑定飞书」入口），同一飞书身份不可被多个账号使用', type: '需求开发'},
        {date: '2026/09/28', content: '支持解绑飞书，解除后账号飞书绑定即时失效', type: '需求开发'},
        {date: '2026/09/28', content: '飞书授权回调跳转 /home，并按登录状态分流（已登录绑定当前账号 / 未登录走飞书登录）', type: '功能调整'},
        {date: '2026/09/28', content: '已绑定飞书的账号再次触发授权时提示「您已绑定飞书」，避免重复绑定', type: '功能调整'},
        {date: '2026/09/28', content: '登录后若未绑定飞书，自动弹出飞书授权绑定引导', type: '需求开发'},
        {date: '2026/09/28', content: '基本资料页「去绑定钉钉」改为扫码绑定组件，绑定成功即时刷新', type: '功能调整'},
        {date: '2026/09/28', content: '钉钉绑定入口移至基本资料页（移除登录后的全局自动弹出）', type: '功能调整'},
        {date: '2026/09/28', content: '飞书绑定页新增「返回登录页面」按钮', type: '功能调整'},
      ]
    };
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    userInfo() {
      return this.$store.getters.getUser;
    },
    userDingDing() {
      return localStorage.getItem('userDingDing') ? JSON.parse(localStorage.getItem('userDingDing')) : false;
    }
  },
  created() {
    //消息通知阅读情况获取
    this.getSummaryNotify();
    // 检测飞书绑定情况：未绑定则在首页提示
    this.checkFeishuBind();
  },
  methods: {
    goBack() {
      this.$router.push({path: '/login'});
      // this.$router.back();
    },
    toDingDing() {
      window.location.href = `dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=${config.DD_ADMINISTRATOR_ID}`
    },
    getSummaryNotify() {
      summaryNotify().then((res) => {
        if (res.model) {
          this.summaryNotify = res.model.summary
        }
      })
    },
    toNotify() {
      this.$router.push({name: 'notify'});
    },
    // 检测是否已绑定飞书：未绑定则显示首页提示条
    checkFeishuBind() {
      // 本次会话内已关闭过提示则不再打扰
      if (sessionStorage.getItem('home_fs_tip_hidden') === '1') return
      myThirdPartyBindings().then((res) => {
        if (res.success && res.model && res.model.feishu && !res.model.feishu.bound) {
          this.fsUnbound = true
        }
      }).catch(() => {
        // 检测失败静默处理，不阻塞首页
      })
    },
    // 关闭提示（非强制）：本会话内不再提示
    closeFsTip() {
      this.fsUnbound = false
      this.fsTipHidden = true
      sessionStorage.setItem('home_fs_tip_hidden', '1')
    },
    // 前往基本资料页绑定飞书
    toBindFeishu() {
      this.$router.push({path: '/personal/updateInfo'})
    }
  }
};
</script>
<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 100%;
  margin-bottom: 10px;
  text-align: left;
}

.homeContent {
  background: #f3f3f3;
  padding: 10px 16px;
  /*margin-top: 70px;*/
  box-sizing: border-box;
  min-height: calc(100vh - 70px);
}

.noPermisson {
  margin-top: 10%;
}

.noPer {
  width: 173px;
  height: 134px;
}
</style>
